module.exports = __webpack_public_path__ + "static/media/lyon1.ad77522d.png";